<template id="info">
   <div class="info-section">
      <h1>About Me</h1>
      <div class="info-box">
         <!-- <v-img
            :aspect-ratio="1"
            width="250"
            class="project-img"
            :src="require(`../assets/img/profile2.jpg`)"
         ></v-img> -->
         <div class="fake-img"></div>
         <ul class="info-txt">
            <li class="first">
               Hi, I'm Noa Nissim, I'm a fullstack / frontend web developer.
            </li>
            <li>
               I'm expreienced in writing single-page-applications using the
               latest WEB technologies like: Vue.js, Vuex, Node.js, React.js,
               Redux, Angular, MongoDB, etc.
            </li>
            <li>
               I'm passionate about technology and UX, striving to be the best,
               eager to face complex tasks, and a team player.
            </li>
         </ul>
      </div>
   </div>
</template>

<script>
export default {
   data() {
      return {
      }
   },
   components: {
   },
}
</script>

